"use client";
import { ThemesResponse } from "@/app/actions/get-problems";
import { ProblemCarousel } from "./problem-carousel";

interface ThemeListProps {
  data: ThemesResponse | null;
}
export function ThemeList({ data }: ThemeListProps) {
  if (!data) {
    return null;
  }

  return (
    <div className="order-2 col-span-4">
      {data.temas.map((tema, index) => (
        <ProblemCarousel key={tema.id} theme={tema} pos={index} />
      ))}
    </div>
  );
}
